import { jsx } from "react/jsx-runtime";
import { forwardRef, Children, isValidElement, cloneElement } from "react";
import PropTypes from "prop-types";
import { TabList } from "./tab-list.es.js";
import { TabBarWrapper } from "./tab-bar.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired
};
const TabBar = forwardRef(({ children, ...restProps }, ref) => /* @__PURE__ */ jsx(TabBarWrapper, { children: Children.map(
  children,
  (child) => isValidElement(child) && child.type === TabList ? cloneElement(child, { ref, ...restProps }) : child
) }));
TabBar.propTypes = propTypes;
export {
  TabBar
};
